// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lBGB","index":"styles_index__ZxPe3"};